<template>
  <div class="virtual-organization">
    <AppBar />
    <div class="page-content">
      <div class="page-canvas">
        <div class="page-background">
          <img :src="top.imgBack" alt="" />
        </div>
        <div class="por-container">
          <div class="solution-info">
            <div class="solution-info-title">{{ top.title }}</div>
            <div class="solution-info-content" v-html="top.content">
              <!-- 利用在线招聘流程，帮助企业实现智能、便捷的招聘模式，
              建立企业自己的人才储备机制 -->
            </div>
          </div>
        </div>
      </div>
      <div ref="nav" class="page-nav">
        <div ref="navTabs" class="page-tabs" :style="{width: navWidth+'%', height: navHeight+'px'}">
          <div
            v-for="(item, index) in navList"
            :key="index"
            :class="['page-nav-item', topNaviId === item.id ? 'top-nav-item' : '']"
            @click="goAnchor(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <div>
        <div ref="pain-points" class="pain-points">
          <div class="title">虚拟组织痛点</div>
          <div class="pain-points-list">
            <div
              v-for="(item, index) in painPointsList"
              :key="index"
              class="pain-points-list-item"
            >
              <div class="list-item-icon">
                <img :src="item.icon" alt="" />
              </div>
              <div class="list-item-title">{{ item.title }}</div>
              <div class="list-item-describe">{{ item.describe }}</div>
            </div>
          </div>
        </div>
      </div>
      <div ref="sense-of-worth">
        <div style="width: 100%; height: 30px; background-color: #f7f9fc;"></div>
        <div class="sense-of-worth">
          <div class="title">产品价值体现</div>
          <div class="sense-of-worth-list">
            <div
              v-for="(item, index) in senseOfWorthList"
              :key="index"
              class="sense-worth-list-item"
            >
              <div class="list-item-img-box">
                <img :src="item.img" alt="" class="list-item-img" />
              </div>
              <div class="list-item-text-box">
                <div class="list-item-title">
                  {{ item.title }}
                </div>
                <div class="list-item-describe">
                  {{ item.describe }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div ref="solution" class="solution">
          <div class="title">虚拟组织解决方案</div>
          <div v-if="solutionContentList.length != 0" class="solution-content">
            <div class="solution-tag">
              <div
                v-for="(item, index) in solutionContentList"
                :key="index"
                class="solution-tag-item"
                :class="{'display-tag-item': index === solutionTagActiveIndex}"
                @mouseenter="displayTag(index)"
              >
                <div class="tag-item-title">
                  <div class="title-text">{{ item.title }}</div>
                  <img v-if="index !== solutionTagActiveIndex" :src="require('@/assets/cloudplatform/icon/right-arrow.png')" alt="" />
                  <img v-else :src="require('@/assets/cloudplatform/icon/down-arrow.png')" alt="" />
                </div>
                <div class="tag-item-describe">
                  <div
                    class="describe"
                  >
                    {{ item.describe }}
                  </div>
                </div>
              </div>
            </div>
            <transition name="solution-fade">
              <div :key="solutionTagActiveIndex" class="fade-content">
                <img :src="solutionContentList[solutionTagActiveIndex].img" alt="" />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <RightFixedgt />
    <FootWrap />
    <AltProduct ref="altProduct" />
    <ast ref="ast" />
  </div>
</template>

<script>
import { getColumnChild, getColumnDetail } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';

export default {
  name: 'VirtualOrganization',
  data () {
    return {
      top: {
        title: '',
        content: '',
        imgBack: require('@/assets/organization/canvas.gif'),
      },
      navWidth: 80,
      navHeight: 60,
      offsetTop: 0,
      scrollTop: 0,
      position: 0,
      topNaviId: null,
      navList: [
        {
          title: '企业痛点',
          id: 'pain-points',
        },
        {
          title: '产品价值观',
          id: 'sense-of-worth',
        },
        {
          title: '解决方案',
          id: 'solution',
        },
      ],
      painPointsList: [
        // {
        //   icon: require('@/assets/organization/icon/pain-points1.png'),
        //   title: '优势资源分散，不能共享',
        //   describe: '组织中的优秀人才和资源由于职能的划分往往比较分散，在不改变现有组织形态的前提下需要有效利用优势资源应对外部环境变化。',
        // },
        // {
        //   icon: require('@/assets/organization/icon/pain-points2.png'),
        //   title: '如何强化组织之间的协同',
        //   describe: '由于主体架构决定了层级关系，导致各组织之间的协同工作出现许多障碍，降低了工作效率。',
        // },
        // {
        //   icon: require('@/assets/organization/icon/pain-points3.png'),
        //   title: '临时组织如何管理',
        //   describe: '企业为应对市场变化或特定情况成立的临时性虚拟组织，不能有效监管，汇报机制不健全。',
        // },
      ],
      senseOfWorthList: [
        // {
        //   title: '形成动态联盟',
        //   describe: '组织或组织成员不受时间和地理空间的限制，资源优化利用，灵活性强，更好的实现组织目标',
        //   img: require('@/assets/organization/sense-of-worth1.png'),
        // },
        // {
        //   title: '组织扁平化',
        //   describe: '虚拟组织通过协作和契约关系，使得企业的管理组织扁平化、信息化，削减了中间层次，使决策层贴近执行层据',
        //   img: require('@/assets/organization/sense-of-worth2.png'),
        // },
        // {
        //   title: '协同工作',
        //   describe: '更好的利用企业人力资源，可以保证合作各方实现资源共享、优势互补和有效合作 ',
        //   img: require('@/assets/organization/sense-of-worth3.png'),
        // },
        // {
        //   title: '提升组织经营绩效',
        //   describe: '虚拟组织内部成员的专业化可以看做是组织能力的分工，这种分工可以产生协同效应，使得整个虚拟组织的经营绩效高于单独经营绩效之和 ',
        //   img: require('@/assets/organization/sense-of-worth4.png'),
        // },
      ],
      solutionContentList: [
        // {
        //   title: '项目组管理模式',
        //   describe: '在不改变现有组织架构的前提下，可以将企业中的部分管理人才进行整合，成立临时性项目组，能更好的通过系统对项目进度和任务进行管控。',
        //   img: require('@/assets/organization/solution1.png'),
        // },
        // {
        //   title: '敏捷组织管理',
        //   describe: '在某些特定项目完成后可以快速解散，不影响组织成员的实体组织关系，实现资源的最大化利用。',
        //   img: require('@/assets/organization/solution2.png'),
        // },
        // {
        //   title: '提升组织成员能力',
        //   describe: '在虚拟组织的管理过程中，组织成员进行知识和技术共享，同步完成知识转移的动作，为整个团队的提升带来动力。',
        //   img: require('@/assets/organization/solution3.png'),
        // },
      ],
      solutionTagActiveIndex: 0,
    };
  },
  watch: {
    scrollTop(newValue, oldValue) {
      setTimeout(() => {
        if (newValue === window.scrollY) {
          for (var i = 0; i < this.navList.length; i++) {
            var elementTop = this.$refs[`${this.navList[i].id}`].offsetTop - this.scrollTop - 1;
            if (elementTop <= 70) {
              this.topNaviId = this.navList[i].id;
            }
          }
        }
      }, 20);
    },
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
    this.$nextTick(() => {
      const nav = this.$refs.nav;
      this.offsetTop = nav.offsetTop;
    });
    this.getPageColumn();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      var offsetHeight = this.$refs.navTabs.offsetHeight;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var headerFixed = this.scrollTop > this.offsetTop - offsetHeight / 2 - 70;
      var scroll = this.scrollTop - this.position;
      this.position = this.scrollTop;
      if (this.scrollTop <= 400) {
        this.navHeight = 52;
        this.navWidth = 80;
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (this.scrollTop >= 400 && !headerFixed) {
        this.navHeight += 0.04 * scroll;
        this.navWidth += 0.12 * scroll;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'relative';
        this.$refs.nav.style.top = '0px';
        this.topNaviId = null;
      } else if (headerFixed) {
        this.navHeight = 60;
        this.navWidth = 100;
        this.$refs.navTabs.style.top = -(offsetHeight / 2) + 'px';
        this.$refs.nav.style.position = 'fixed';
        this.$refs.nav.style.top = offsetHeight / 2 + 70 + 'px';
      }
    },
    goAnchor(i) {
      // var id = '#' + i.id;
      // document.querySelector(id).scrollIntoView({
      //   behavior: 'smooth',
      //   block: 'start',
      // });
      window.scrollTo({
        top: this.$refs[`${i.id}`].offsetTop - 70,
        left: 0,
        behavior: 'smooth',
      });
    },

    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1607260919291928576', };
      getColumnChild(params).then(async (res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '企业痛点') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;
                var painPointsItem = {
                  title: rtsult.title,
                  icon: rtsult.icon,
                  describe: rtsult.description,
                };
                this.painPointsList.push(painPointsItem);
              }
            });
          } else if (result[i].name === '产品价值观') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            this.valueCenterImg = result[i].icon;
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var senseOfWorthItem = {
                  title: rrsult.data[j].title,
                  img: rrsult.data[j].icon,
                  describe: rrsult.data[j].description,
                };
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   valueAnalysisItem.textList.push(rtsult.elements[x].content);
                // }
                this.senseOfWorthList.push(senseOfWorthItem);
              }
            });
          } else if (result[i].name === '解决方案') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var solutionContent = {
                  title: rrsult.data[j].title,
                  describe: rrsult.data[j].description,
                  img: rrsult.data[j].icon,
                };
                // const rts = await getContentDetail(rrsult.data[j].id);
                // const rtsult = rts.result;
                // for (var x = 0; x < rtsult.elements.length; x++) {
                //   solutionItem.contentList.push(rtsult.elements[x].content);
                // }
                this.solutionContentList.push(solutionContent);
              }
            });
          } else if (result[i].name === '顶部图') {
            getColumnDetail(result[i].id).then((rrs) => {
              const rrsult = rrs.result;
              var content = rrsult.elements.find(obj => obj.name === 'content').content;
              var contentdoc = new DOMParser().parseFromString(content, 'text/html');
              this.top.title = rrsult.elements.find(obj => obj.name === 'subtitle').content;
              this.top.content = contentdoc.documentElement.textContent.replace(/&nbsp;/g, ' ');
              // this.top = {
              //   imgBack: rrsult.icon,
              // };
            });
          }
        }
      });
    },

    displayTag(index) {
      this.solutionTagActiveIndex = index;
    },
    openBealter () {
      this.$refs.altProduct.tobealter();
    },
    openBealter2() {
       this.$refs.ast.drawer  = true
    },
  },
};
</script>

<style lang="less" scoped>
.virtual-organization{
    background-color: #fff;
    .page-content{
      width: 100%;
      .page-canvas{
        width: 100%;
        height: fit-content;
        min-width: var(--minwidth);
        position: relative;
        background-size: cover;
        overflow: hidden;
        .page-background{
          position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
          img{
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center top;
          }
        }
        .por-container {
        width: 70%;
        max-width: 1200px;
        margin: 0 auto;
        position: relative;
        .solution-info {
          width: 480px;
          height: 560px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          box-sizing: border-box;
          .solution-info-title {
            font-size: 46px;
            font-weight: bold;
            line-height: 55px;
            color: #181818;
            margin-bottom: 29px;
          }
          .solution-info-content {
            font-size: 20px;
            line-height: 32px;
            color: #7b7b7b;
            margin-bottom: 44px;
          }
          // .solution-btn {
          //   width: 142px;
          //   height: 48px;
          //   background-color: #1589fd;
          //   color: #fff;
          //   text-align: center;
          //   line-height: 48px;
          //   cursor: pointer;
          //   border-radius: 24px;
          // }
        }
      }
      }
      .page-nav{
            width: 100%;
            display: flex;
            position: relative;
            justify-content: center;
            z-index: 50;
            .page-tabs{
                margin: 0 auto;
                box-shadow: 0px 2px 8px 0px rgba(139, 139, 139, 0.18);
                border-radius: 2px;
                background-color: #fff;
                display: flex;
                position: absolute;
                top: -26px;
                .page-nav-item{
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #181818;
                font-size: 14px;
                cursor: pointer;
                }
                .page-nav-item:hover{
                color: #00b0dc;
                }
                .top-nav-item {
                color: #fff;
                background-color: #00b0dc;
                }
                .top-nav-item:hover {
                color: #fff;
                }
            }
      }
      .pain-points{
            width: 100%;
            padding-top: 115px;
            padding-bottom: 60px;
            background-color: #f7f9fc;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .title{
                font-size: 32px;
                color: #181818;
                line-height: 1;
                margin-bottom: 70px;
            }
            .pain-points-list{
                width: 1200px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .pain-points-list-item{
                    width: 380px;
                    height: 360px;
                    padding-top: 40px;
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-sizing: border-box;
                    background-color: transparent;
                    transition: all 0.5s ease-in-out;
                    .list-item-icon{
                        width: 72px;
                        height: 72px;
                        background-color: transparent;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-bottom: 40px;
                        transition: all 0.5s ease-in-out;
                        img{
                           width: 36px;
                           height: auto;
                        }
                    }
                    .list-item-title{
                        font-weight: 600;
                        font-size: 22px;
                        color: #181818;
                        margin-bottom: 20px;
                        line-height: 1;
                    }
                    .list-item-describe{
                        width: 284px;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 26px;
                        color: #181818;
                    }
                }
                .pain-points-list-item:hover{
                    background-color: #fff;
                    box-shadow: 0px 3px 24px 0px rgba(139, 139, 139, 0.1);
                    .list-item-icon{
                        background-color: #f7f8fa;
                    }
                }
            }
      }
      .sense-of-worth{
        width: 1200px;
        margin: 0 auto;
        margin-top: 90px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .title{
          font-size: 32px;
          color: #181818;
        }
        .sense-of-worth-list{
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-top: 70px;
          .sense-worth-list-item{
            width: 282px;
            height: 470px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            background-color: #fff;
            border-radius: 10px;
            border: 1px solid #eee;
            box-shadow: 0px 3px 24px 0px rgba(139, 139, 139, 0.1);
            transform: translateY(0);
            transition: all .3s ease-in-out;
            .list-item-img-box{
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              .list-item-img{
                width: auto;
              }
            }
            .list-item-text-box{
              width: 195px;
              height: 197px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              .list-item-title{
                font-size: 24px;
                font-weight: 600;
                line-height: 1;
                color: #181818;
                margin-bottom: 29px;
              }
              .list-item-describe{
                text-align: center;
                font-size: 14px;
                font-weight: 400;
                color: #6d6e6f;
              }
            }
          }
          .sense-worth-list-item:hover{
            transform: translateY(-15px);
          }
        }
      }
      .solution{
        width: 1200px;
        padding-top: 109px;
        padding-bottom: 90px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title{
          font-size: 32px;
          color: #181818;
          line-height: 1;
          padding-bottom: 90px;
          box-sizing: border-box;
        }
        .solution-content{
          width: 100%;
          height: 460px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .solution-tag{
            width: 440px;
            height: 428px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            .solution-tag-item{
              width: 100%;
              height: 83px;
              padding: 31px;
              margin-bottom: 16px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              box-sizing: border-box;
              background-color: #f5f7f9;
              border-radius: 8px;
              cursor: pointer;
              transition: all .3s ease-in-out;
              .tag-item-title {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                transition: all .3s ease-in-out;
                margin-bottom: 20px;
                .title-text{
                  font-weight: 600;
                  font-size: 18px;
                  color: #181818;
                  transition: all .3s ease-in-out;
                }
              }
              .tag-item-describe{
                width: 100%;
                flex: 1;
                overflow: hidden;
                .describe{
                  font-size: 16px;
                  font-weight: 300;
                  color: #181818;
                  line-height: 25px;
                  transition: all .3s ease-in-out;
                }
              }
            }
            .display-tag-item{
              height: 230px;
              background: url('@/assets/cloudplatform/introduction-tag.png') no-repeat;
              background-size: cover;
              .tag-item-title{
                .title-text{
                  color: #fff;
                }
              }
              .tag-item-describe{
                .describe{
                  color: #fff;
                }
              }
            }
            .solution-tag-item:last-child{
              margin: 0;
            }
          }
          .fade-content{
            width: 740px;
            img{
                width: 100%;
                display: block;
            }
          }
          .solution-fade-enter-active{
            animation: bounce-in 0.5s;
          }
          .solution-fade-leave-active{
            animation: bounce-in 0s reverse;
          }
          @keyframes bounce-in {
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
          }
        }
      }
    }
}
</style>
